import { createSelector } from "reselect";
import getSearchResultsSelector from "./getSearchResultsSelector";

export default createSelector(getSearchResultsSelector, results => {
    return {
        total: results.length,
        profession: results.filter(e => e.post_type === "profession").length,
        school: results.filter(e => e.post_type === "school").length
    };
});
